import {SIDEBAR_STATE} from './sidebarActionTypes';

export function sidebarState() {
    return {type: SIDEBAR_STATE};
}
